<template>
<v-container>
  <h1>Werkstattaufträge</h1>
  <p>Hier sehen Sie, welche Geräte Sie bei uns in der Werkstatt hatten.</p>
  <v-data-table v-bind:headers="headers" :items="serviceorders" v-bind:pagination.sync="pagination" :rows-per-page-text="'Aufträge pro Seite'" :no-data-text="'Keine Aufträge vorhanden'" class="elevation-3">
    <template slot="items" slot-scope="props">
        <td class="text-xs-right">{{ moment(props.item.order_date).format('L') }}</td>
        <td>{{ props.item.device }}</td>
        <td>{{ props.item.accessoires }}</td>
        <td>{{ props.item.description }}</td>
        <td>{{ props.item.comment }}</td>
        <td>{{ props.item.state }}</td>
        <td class="text-xs-right"><a v-if="props.item.invoice" @click="invoiceDownload(props.item.invoice.invoice_id)">herunterladen</a></td>
      </template>
  </v-data-table>
</v-container>
</template>
<script>
import moment from 'moment'
moment.locale('de')

export default {
  data() {
    return {
      moment: moment,
      headers: [{
        text: 'Auftragsdatum',
        value: 'order_date'
      }, {
        text: 'Gerät',
        value: 'device',
        align: 'left'
      }, {
        text: 'Zubehör',
        value: 'accessoires',
        align: 'left'
      }, {
        text: 'Beschreibung',
        value: 'description',
        align: 'left'
      }, {
        text: 'Bemerkung',
        value: 'comment',
        align: 'left'
      }, {
        text: 'Status',
        value: 'state',
        align: 'left'
      }, {
        text: 'Beleg',
        sortable: false
      }],
      serviceorders: [],
      pagination: {
        sortBy: 'order_date',
        descending: true,
        rowsPerPage: 10
      }
    }
  },
  created() {
    this.$api.service.findServiceOrder().then((response) => {
      this.serviceorders = response.data
    })
  },
  methods: {
    invoiceDownload: function(invoiceId) {
      this.$api.order.invoiceDownload({
        invoice_id: invoiceId
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// ServiceOrderOverview.vue?3a393080